import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useAccountDetail } from '@/hooks/accounts/useAccountDetail.ts';

interface AccountInfoTooltipProps {
  accountId: string;
  accountName: string;
  navigateTo: string;
}

function TooltipBody({ accountId }: { accountId: string }) {
  const { data: account } = useAccountDetail(accountId);

  if (!account) return <span className="text-sm text-muted-foreground">Loading…</span>;

  return (
    <div className="flex flex-col gap-1 text-sm">
      {account.nickname && (
        <div><span className="text-muted-foreground">Nickname: </span>{account.nickname}</div>
      )}
      <div><span className="text-muted-foreground">Balance: </span>{account.balance}</div>
      <div><span className="text-muted-foreground">Currency: </span>{account.currency}</div>
      <div><span className="text-muted-foreground">Type: </span>{account.type}</div>
      {account.account_number && (
        <div><span className="text-muted-foreground">Account #: </span>{account.account_number}</div>
      )}
    </div>
  );
}

export function AccountInfoTooltip({ accountId, accountName, navigateTo }: AccountInfoTooltipProps) {
  const [open, setOpen] = useState(false);

  return (
    <TooltipProvider>
      <Tooltip open={open} onOpenChange={setOpen}>
        <TooltipTrigger asChild>
          <Link to={navigateTo} className="text-primary underline-offset-4 hover:underline">
            {accountName}
          </Link>
        </TooltipTrigger>
        <TooltipContent>
          {open && <TooltipBody accountId={accountId} />}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
